import Svg, { Circle, Path, Defs, LinearGradient, Stop } from "react-native-svg";

interface AiIconLgProps {
  size?: number;
}

export function AiIconLg({ size = 56 }: AiIconLgProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 56 56" fill="none">
      {/* @ts-expect-error react-native-svg Defs children typing incomplete with React 19 types */}
      <Defs>
        <LinearGradient id="aiIconLgGradient" x1="0" y1="0.951" x2="65.6" y2="40.1" gradientUnits="userSpaceOnUse">
          <Stop stopColor="#12C9FD" />
          <Stop offset="0.445451" stopColor="#2431A0" />
          <Stop offset="0.994505" stopColor="#F23D6F" />
        </LinearGradient>
      </Defs>
      <Circle cx="28" cy="28" r="28" fill="url(#aiIconLgGradient)" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6 27.4L25.1 19.9H26.7L29.2 27.4L36.7 30.0V31.5L29.2 34.1L26.7 41.6H25.1L22.6 34.1L15.1 31.5V30.0L22.6 27.4Z"
        fill="white"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.8 17.8L38.1 14H39.6L40.9 17.8L44.7 19.1V20.6L40.9 21.9L39.6 25.7H38.1L36.8 21.9L33 20.6V19.1L36.8 17.8Z"
        fill="white"
      />
    </Svg>
  );
}
